import { useCallback } from 'react'
import { useAsync } from 'react-use'
import {
  isAppVersionGreaterThanOrEqualTo,
} from 'src/utils/jsBridge/implementation'
import { isAppWebview } from 'src/utils/userAgent'
import { ensureLogIn } from 'src/utils/user'
import { useDailyClaimInfo } from 'src/services/orpc/claim'
import { openForceVerifyEmailDialog } from './openForceVerifyEmailDialog'

function useNativeSupportEditAccount() {
  const isWebview = isAppWebview()
  const { value: supportEditAccount } = useAsync(() => {
    if (!isWebview) return Promise.resolve(false)
    return isAppVersionGreaterThanOrEqualTo('3.25.0')
  }, [isWebview])
  return supportEditAccount
}

export function useEmailVerificationStatus() {
  const { data: claimInfo } = useDailyClaimInfo()

  const emailVerificationRequiredSince =
    claimInfo?.emailVerificationRequiredSince ?? null
  const isEmailVerificationBlocking =
    emailVerificationRequiredSince != null &&
    emailVerificationRequiredSince <= Date.now()
  const isEmailVerificationWarning =
    emailVerificationRequiredSince != null &&
    emailVerificationRequiredSince > Date.now()

  return { isEmailVerificationBlocking, isEmailVerificationWarning }
}

export function useCheckEmailVerified() {
  const supportNativeEditAccount = useNativeSupportEditAccount()
  const { isEmailVerificationBlocking } = useEmailVerificationStatus()

  return useCallback(async (): Promise<boolean> => {
    await ensureLogIn()

    if (isEmailVerificationBlocking) {
      openForceVerifyEmailDialog({ supportNativeEditAccount })
      return false
    }

    return true
  }, [supportNativeEditAccount, isEmailVerificationBlocking])
}
